﻿$.fn.dxCtrlChartComEnvoiLigneResume = function custom_dxCtrlChartComEnvoiLigneResume(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlchartcomenvoiligneresume dx-ctrl");
        this.createInstance(new cdxCtrlChartComEnvoiLigneResume(this, option));
    }
    return this;
}

window.cdxCtrlChartComEnvoiLigneResume = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $TrEnCours = null
    var $TdWarnning=null
    var $TdJauge = null
    var $TdNbDest = null
    var $TdNbEnvoye = null
    var $TdAttenteEnvoi = null
    var $TdBounce = null
    var $TdNbAnnule = null
    var $TdNbDelivre = null
    var $TdLNbListeNoire = null
    function mConstruit() {
        container.empty()

        var $Table = $("<table style='display:inline-block;height:16px;'/>").appendTo(container)
        var $TrResume = $("<tr/>").appendTo($Table)
        var $TdResume = $("<td/>").appendTo($TrResume)
        //if (option.dataPlus.tracking == "1" && option.dataPlus.id_type_classement != "7") {
        if (option.dataPlus.id_type_classement != "7") {
            //$TrResume.css("font-weight", "bold")
            var $TableEncours = $("<table/>").appendTo($TdResume)
            $TrEnCours = $("<tr/>").appendTo($TableEncours)
            $TdWarnning = $("<td style='width:1px;color:red;'>⚠</td>").appendTo($TrEnCours)
            $TdJauge = $("<td style='width:1px;white-space:nowrap;white-space:nowrap;padding-right:5px;' title='Envoi en cours'><img src='" + parametre.urldispatch + "/img/jauge2.svg' style='width:14px;display:block'/></td>").appendTo($TrEnCours)
            $TdNbDest = $("<td style='width:1px;white-space:nowrap;white-space:nowrap;padding-right:5px;'/>").appendTo($TrEnCours)
            $TdNbEnvoye = $("<td style='width:1px;white-space:nowrap;color:gray;white-space:nowrap;padding-right:5px;'/>").appendTo($TrEnCours)
            $TdAttenteEnvoi = $("<td style='width:1px;white-space:nowrap;color:blue;white-space:nowrap;padding-right:5px;'/>").appendTo($TrEnCours)
            $TdBounce = $("<td style='width:1px;white-space:nowrap;color:red;white-space:nowrap;padding-right:5px;'/>").appendTo($TrEnCours)
            $TdNbAnnule = $("<td style='width:1px;white-space:nowrap;color:brown;white-space:nowrap;padding-right:5px;'/>").appendTo($TrEnCours)
            $TdNbDelivre = $("<td style='width:1px;white-space:nowrap;color:green;white-space:nowrap;padding-right:5px;'/>").appendTo($TrEnCours)
            $TdLNbListeNoire = $("<td style='width:1px;white-space:nowrap;color:orange;white-space:nowrap;padding-right:5px;'/>").appendTo($TrEnCours)

            Me.mUpdate()
            //function mGetResume() {
            //    option.bddCtrl.mAjaxCall({
            //        command: "getresumeenvoi",
            //        id_table_com: option.dataPlus.id_table_key,
            //        id_com: option.dataPlus.id_key
            //    }, function (data) {
            //        if (option.dataPlus.date_envoi == null || option.dataPlus.id_type_classement == "9") { $TdJauge.show() } else { $TdJauge.hide() }
            //        $TdNbDest.text(data.stat[0].nb_dest);
            //        $TdNbEnvoye.text(data.stat[0].nb_envoi);
            //        $TdAttenteEnvoi.text(data.stat[0].nb_attente);
            //        if (data.stat[0].nb_attente == 0) { $TdAttenteEnvoi.hide() } else { $TdAttenteEnvoi.show() }
            //        $TdBounce.text(data.stat[0].nb_listegrise);
            //        if (data.stat[0].nb_listegrise == 0) { $TdBounce.hide() } else { $TdBounce.show() }
            //        $TdNbAnnule.text(data.stat[0].nb_annule);
            //        if (data.stat[0].nb_annule == 0) { $TdNbAnnule.hide() } else { $TdNbAnnule.show() }
            //        $TdNbDelivre.text(data.stat[0].nb_delivre);
            //        $TdLNbListeNoire.text(data.stat[0].nb_listenoire);
            //        if (data.stat[0].nb_listenoire == 0) { $TdLNbListeNoire.hide() } else { $TdLNbListeNoire.show() }
            //        if (container.closest("body").length > 0 && option.dataPlus.date_envoi == null) window.setTimeout(function () { mGetResume() }, 5000)

            //        var title = ""
            //        title = "Nb destinataire: " + data.stat[0].nb_dest + "<br/><span style='color:gray'>Envoyés:" + data.stat[0].nb_envoi + "</span>"
            //        if (data.stat[0].nb_attente > 0) title += "<br/><span style='color:blue'>Attente envoi:" + data.stat[0].nb_attente + "</span>"
            //        if (data.stat[0].nb_listegrise > 0) title += "<br/><span style='color:red'>Liste grise:" + data.stat[0].nb_listegrise + "</span>"
            //        if (data.stat[0].nb_annule > 0) title += "<br/><span style='color:brown'>Annulé:" + data.stat[0].nb_annule + "</span>"
            //        title += "<br/><span style='color:green'>Délivré:" + data.stat[0].nb_delivre + "</span>"
            //        if (data.stat[0].nb_listenoire > 0) title += "<br/><span style='color:orange'>Liste noire:" + data.stat[0].nb_listenoire + "</span>"
            //        $TrEnCours.attr("title", title)

            //        if (data.stat[0].nb_attente == 0) {
            //            //le traitement est fini
            //            //tout est envoyé
            //        } else {
            //            if (option.update) if (container.closest("body").length > 0) window.setTimeout(function () {
            //                mConstruit()
            //            }, 5000)
            //        }

            //    })
            //}
            //mGetResume()

        }

        var $Td = $("<td style='white-space:nowrap;" + ((option.dataPlus.tracking == "1") ? "padding-left:5px;" : "") + "'/>").appendTo($TrResume)
        //if (option.dataPlus.tracking == "1") {
        if (option.dataPlus.nb_vue > 0 || option.dataPlus.nb_click > 0) {
            if (option.dataPlus.nb_vue > 0) {
                $("<span title='" + option.dataPlus.nb_vue + " vue" + ((option.dataPlus.nb_vue > 1) ? "s" : "") + "%cr%(dernière vue le " + option.dataPlus.last_date_vue.toFrenchDateTime() + ")'><i class='fas fa-eye dx-theme-accent-as-text-color' style='padding-right:3px;'></i> (" + option.dataPlus.nb_vue + ") " + option.dataPlus.last_date_vue.toDateIlya(true) + "</span>").appendTo($Td)
            }
            if (option.dataPlus.nb_click > 0) {
                if (option.dataPlus.nb_vue > 0) { $("<span> &bull; </span>").appendTo($Td) }
                $("<span title='" + option.dataPlus.nb_click + " click" + ((option.dataPlus.nb_click > 1) ? "s" : "") + "%cr%(dernier click le " + option.dataPlus.last_date_click.toFrenchDateTime() + ")'><i class='fas fa-arrow-pointer dx-theme-accent-as-text-color' style='padding-right:3px;'></i> (" + option.dataPlus.nb_click + ") " + option.dataPlus.last_date_click.toDateIlya(true) + "</span>").appendTo($Td)
            }
            $("<span> &bull; </span>").appendTo($Td)
        }
        //}

        var exp = ""
        if (option.dataPlus.id_table_key == option.bddCtrl.table.mGetItemFromNom("com_email_envoi").id_table) {
            exp = "(" + option.dataPlus.email_expediteur + ") &bull;"
        }

        if (option.dataPlus.date_envoi == null) {
            $("<span>" + exp + "<span title='" + option.dataPlus.dcr.toFrenchDateTime() + "'>Créé " + option.dataPlus.dcr.toDateIlya(true) + "</span></span>").appendTo($Td)
        } else {
            if (option.dataPlus.date_envoi > parametre.dateNow) {
                //envoi différé    
                var $SpanEnvoiAttente = $("<span>" + exp + "<span><img src='" + parametre.urldispatch + "/img/jauge.svg' style='width:10px;display:inline-block'/> </span></span>").appendTo($Td)
                $SpanDateEnvoiAttente = $("<span title='" + option.dataPlus.date_envoi.toFrenchDateTime() + "'></span>").appendTo($SpanEnvoiAttente)
                mMajDateEnvoi()
                function mMajDateEnvoi() {
                    if ($SpanDateEnvoiAttente.closest("body").length == 0) return
                    if (diffdate(parametre.dateNow, option.dataPlus.date_envoi, "s") > 180) {
                        $SpanDateEnvoiAttente.html("Sera envoyé " + option.dataPlus.date_envoi.toDateIlya(true))
                    } else {
                        $SpanDateEnvoiAttente.html("Envoyé dans " + (new Date()).decompte(option.dataPlus.date_envoi))
                    }
                    window.setTimeout(function () { mMajDateEnvoi() }, ((diffdate(option.dataPlus.date_envoi, parametre.dateNow, "s") > 180) ? 10000 : 1000))
                }
            } else {
                $("<span>" + exp + "<span title='" + option.dataPlus.date_envoi.toFrenchDateTime() + "'>Envoyé " + option.dataPlus.date_envoi.toDateIlya(true) + "</span></span>").appendTo($Td)
            }
        }
    }

    var timeoutUpdate = null
    this.mUpdate = function () {
        option.bddCtrl.mAjaxCall({
            command: "getresumeenvoi",
            id_table_com: option.dataPlus.id_table_key,
            id_com: option.dataPlus.id_key
        }, function (data) {
            if (data.stat[0].nb_error > 0) { $TdWarnning.show() } else { $TdWarnning.hide() }
            $TdNbDest.text(data.stat[0].nb_dest);
            $TdNbEnvoye.text(data.stat[0].nb_envoi);
            $TdAttenteEnvoi.text(data.stat[0].nb_attente);
            if (data.stat[0].nb_attente == 0) { $TdAttenteEnvoi.hide() } else { $TdAttenteEnvoi.show() }
            $TdBounce.text(data.stat[0].nb_listebounce);
            if (data.stat[0].nb_listebounce == 0) { $TdBounce.hide() } else { $TdBounce.show() }
            $TdNbAnnule.text(data.stat[0].nb_annule);
            if (data.stat[0].nb_annule == 0) { $TdNbAnnule.hide() } else { $TdNbAnnule.show() }
            $TdNbDelivre.text(data.stat[0].nb_delivre);
            $TdLNbListeNoire.text(data.stat[0].nb_listenoire);
            if (data.stat[0].nb_listenoire == 0) { $TdLNbListeNoire.hide() } else { $TdLNbListeNoire.show() }
            window.clearTimeout(timeoutUpdate)
            if (container.closest("body").length > 0 && option.dataPlus.date_envoi == null) {
                timeoutUpdate = window.setTimeout(function () {
                    if (container.closest("body").length > 0 && option.dataPlus.date_envoi == null) Me.mUpdate()
                }, 7000)
            }

            var title = ""
            title = "Nb destinataire: " + data.stat[0].nb_dest + "<br/><span style='color:gray'>Envoyés:" + data.stat[0].nb_envoi + "</span>"
            if (data.stat[0].nb_attente > 0) title += "<br/><span style='color:blue'>Attente envoi:" + data.stat[0].nb_attente + "</span>"
            if (data.stat[0].nb_listebounce > 0) title += "<br/><span style='color:red'>Bounce:" + data.stat[0].nb_listebounce + "</span>"
            if (data.stat[0].nb_annule > 0) title += "<br/><span style='color:brown'>Annulé:" + data.stat[0].nb_annule + "</span>"
            title += "<br/><span style='color:green'>Délivré:" + data.stat[0].nb_delivre + "</span>"
            if (data.stat[0].nb_listenoire > 0) title += "<br/><span style='color:orange'>désinscriptions:" + data.stat[0].nb_listenoire + "</span>"
            $TrEnCours.attr("title", title)

            if (data.stat[0].nb_attente == 0) {
                //le traitement est fini
                //tout est envoyé
                $TdJauge.hide()
            } else {
                window.clearTimeout(timeoutUpdate)
                if (container.closest("body").length > 0) timeoutUpdate = window.setTimeout(function () {
                    if (container.closest("body").length > 0) Me.mUpdate()
                }, 7000)
            }
        })
    }

    this.element = function () { return container }
    this.focus = function () { }

    mConstruit();
}